var exports = {
  "vW": "SlashCommandParamBar.module__inner___OG1mSW",
  "Qq": "SlashCommandParamBar.module__text___OG1mSW",
  "UU": "SlashCommandParamBar.module__name___OG1mSW",
  "h_": "SlashCommandParamBar.module__description___OG1mSW",
  "ku": "SlashCommandParamBar.module__requiredError___OG1mSW" + " " + "SlashCommandParamBar.module__description___OG1mSW",
  "ne": "SlashCommandParamBar.module__controls___OG1mSW",
  "x6": "SlashCommandParamBar.module__button___OG1mSW",
  "Kk": "SlashCommandParamBar.module__icon___OG1mSW",
};

module.exports = exports;
